import { render, staticRenderFns } from "./PreviewResponseFile.vue?vue&type=template&id=b984f104&"
import script from "./PreviewResponseFile.vue?vue&type=script&lang=js&"
export * from "./PreviewResponseFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports